export default "__VITE_ASSET__Dw0HTBQa__"